import { useEffect, useState } from "react"

//PrimeReact
import { Accordion, AccordionTab } from "primereact/accordion"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"

//Housing Styles and components
import myStyle from "../../../styles/housing/HousingActivities.module.css"
import { useCallback } from "react"

export default function HousingActivitiesFilter({
  participants,
  participant,
  isLoading,
  houseList,
  onRefreshClick,
  onNewClick,
  onChangeFilters,
  onSetParticipant,
}) {
  //Retrieve relevant context values

  const [filterType, setFilterType] = useState("")
  const [houseId, setHouseId] = useState("")
  const [fromDate, setFromDate] = useState(undefined)
  const [toDate, setToDate] = useState(new Date())
  const [filterParticipant, setFilterParticipant] = useState(undefined)

  const activityOptions = [
    { label: "Medication Management", value: "MedicineManagement" },
    { label: "Substance Use Testing", value: "SubstanceTest" },
    { label: "Other Housing Activity", value: "Other" },
    { label: "All activities", value: "" },
  ]

  const setDefaultStartDate = useCallback(() => {
    let startDate = new Date()
    startDate.setDate(1)
    startDate.setMonth(startDate.getMonth() - 1)

    setFromDate(startDate)

    return startDate
  }, [])

  useEffect(() => {
    setDefaultStartDate()
  }, [setDefaultStartDate])

  useEffect(() => {
    setFilterParticipant(participant)
  }, [participant])

  const FilterHeader = () => {
    return (
      <div className={myStyle.filterHeaderGridContainer}>
        <div className={myStyle.filterHeaderGridTitle}>
          <label>{`Filters | Participant: ${
            !participant ? "No participant selected" : `${participant.name2}`
          }`}</label>
        </div>
        <div className={myStyle.filterHeaderGridButtons}>
          <div className={myStyle.filterButtonContainer}>
            {!!onRefreshClick ? (
              <button
                type="button"
                className={`btn t-tip ${myStyle.filterHeaderButton}`}
                onClick={(e) => {
                  e.stopPropagation()
                  if (!!onRefreshClick) {
                    onRefreshClick()
                  }
                }}
                disabled={isLoading}
              >
                <span className={`material-icons`}>{"autorenew"}</span>
                {" Reload data"}
              </button>
            ) : null}

            <button
              type="button"
              className={`btn t-tip ${myStyle.filterHeaderButton}`}
              onClick={(e) => {
                e.stopPropagation()
                if (!!onNewClick) {
                  onNewClick()
                }
              }}
              disabled={isLoading}
            >
              <span className={`material-icons`}>{"add"}</span>
              {" Add new activity"}
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <Accordion style={{ marginBottom: "10px" }} activeIndex={0}>
        <AccordionTab
          header={FilterHeader()}
          disabled={isLoading}
          headerClassName={myStyle.filterHeader}
        >
          <div className={myStyle.filterBodyGridContainer}>
            <div className={myStyle.filterBodyGridType}>
              <div className={myStyle.label}>Activity Type</div>
              <div>
                <Dropdown
                  className={myStyle.input}
                  options={activityOptions}
                  value={filterType}
                  onChange={(e) => {
                    setFilterType(e.value)
                  }}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={myStyle.filterBodyGridHouse}>
              <div className={myStyle.label}>House</div>
              <div>
                <Dropdown
                  className={myStyle.input}
                  value={houseId}
                  onChange={(e) => {
                    setHouseId(e.value)
                  }}
                  placeholder="All houses"
                  options={[
                    { name: "All houses", id: undefined },
                    ...houseList,
                  ]}
                  optionLabel={"name"}
                  optionValue={"id"}
                  disabled={isLoading}
                  filter
                />
              </div>
            </div>
            <div className={myStyle.filterBodyGridFrom}>
              <div className={myStyle.label}>From Date</div>
              <div>
                <Calendar
                  className={myStyle.input}
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.value)
                  }}
                  maxDate={toDate}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={myStyle.filterBodyGridTo}>
              <div className={myStyle.label}>To Date</div>
              <div>
                <Calendar
                  className={myStyle.input}
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.value)
                  }}
                  minDate={fromDate}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={myStyle.filterBodyGridParticipants}>
              <div className={myStyle.label}>Participant</div>
              <Dropdown
                className={`${myStyle.input}`}
                value={filterParticipant}
                onChange={(e) => {
                  setFilterParticipant(e.value)
                }}
                placeholder="All participants"
                options={[{ name2: "All participants" }, ...participants]}
                optionLabel={"name2"}
                disabled={isLoading}
                filter
              />
            </div>
            <div className={myStyle.filterBodyGridButtons}>
              <div className={myStyle.filterButtons}>
                <button
                  className="btn"
                  type="button"
                  onClick={() => {
                    onChangeFilters({
                      type: filterType,
                      houseId: houseId,
                      fromDate: fromDate,
                      toDate: toDate,
                      participantId: filterParticipant?.participant_id,
                    })
                    onSetParticipant(filterParticipant)
                  }}
                  disabled={isLoading}
                >
                  Apply
                </button>
                <button
                  className={`btn ${myStyle.filterButton}`}
                  type="button"
                  onClick={() => {
                    setFilterType("")
                    setHouseId(undefined)

                    const newStartDate = setDefaultStartDate()
                    const newToDate = new Date()
                    setToDate(newToDate)
                    setFilterParticipant(undefined)

                    onSetParticipant(undefined)
                    onChangeFilters({
                      type: "",
                      houseId: undefined,
                      fromDate: newStartDate,
                      toDate: newToDate,
                      participantId: undefined,
                    })
                  }}
                  disabled={isLoading}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </>
  )
}
